/* ==========================================================================
   Vitrina — theme scripts
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var CART_SECTIONS = 'cart-drawer';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var parseHTML = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
  var debounce = function (fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  };

  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('no-reveal');
  }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var fmt = format || theme.moneyFormat || '{{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var parts = (n / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(re);
    if (!match) return fmt;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(re, value);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(message, type) {
    var el = $('[data-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.className = 'toast is-visible' + (type ? ' toast--' + type : '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ---------- Drawers ---------- */
  var activeDrawer = null;
  var lastFocus = null;

  function hoistDrawers() {
    $$('[data-move-to-body]').forEach(function (el) {
      if (el.parentElement === document.body) return;
      $$('body > #' + el.id).forEach(function (old) { old.remove(); });
      document.body.appendChild(el);
    });
  }

  function openDrawer(el) {
    if (!el) return;
    if (activeDrawer && activeDrawer !== el) closeDrawer(true);
    closeMega();
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    var overlay = $('[data-overlay]');
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('no-scroll');
    activeDrawer = el;
    setTimeout(function () {
      var focusable = el.querySelector('[data-drawer-close]');
      if (focusable) focusable.focus({ preventScroll: true });
    }, 60);
  }

  function closeDrawer(silent) {
    if (!activeDrawer) return;
    activeDrawer.classList.remove('is-open');
    activeDrawer.setAttribute('aria-hidden', 'true');
    activeDrawer = null;
    if (silent === true) return;
    var overlay = $('[data-overlay]');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- Catalog mega menu ---------- */
  function closeMega() {
    var mega = $('[data-mega]');
    var btn = $('[data-mega-toggle]');
    if (!mega || mega.hidden) return;
    mega.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function toggleMega(btn) {
    var mega = $('[data-mega]');
    if (!mega) return;
    var willOpen = mega.hidden;
    mega.hidden = !willOpen;
    btn.setAttribute('aria-expanded', String(willOpen));
  }

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    var n = parseInt(count || 0, 10);
    $$('[data-cart-count-bubble]').forEach(function (b) {
      b.textContent = n;
      b.hidden = n === 0;
    });
  }

  function applyCartHTML(html) {
    var fresh = parseHTML(html).querySelector('[data-cart-drawer-inner]');
    var current = $('[data-cart-drawer-inner]');
    if (fresh && current) current.replaceWith(fresh);
    if (fresh) updateCartCount(fresh.getAttribute('data-cart-count'));
  }

  function refreshCart() {
    return fetch(theme.routes.root + '?sections=' + CART_SECTIONS)
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data && data[CART_SECTIONS]) applyCartHTML(data[CART_SECTIONS]); })
      .catch(function () {});
  }

  function renderCart(sections) {
    if (sections && sections[CART_SECTIONS]) applyCartHTML(sections[CART_SECTIONS]);
    else refreshCart();
  }

  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    var errorEl = form.querySelector('[data-form-error]');
    if (btn) btn.classList.add('is-loading');
    if (errorEl) errorEl.hidden = true;

    var fd = new FormData(form);
    Array.from(fd.keys()).forEach(function (key) {
      if (key.indexOf('option-') === 0) fd.delete(key);
    });
    fd.append('sections', CART_SECTIONS);
    fd.append('sections_url', window.location.pathname);

    fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        var data = result.data || {};
        if (!result.ok || data.status) {
          var msg = data.description || data.message || theme.strings.error;
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
          else toast(msg, 'error');
          return;
        }
        if (theme.cartType === 'page') {
          window.location.href = theme.routes.cart;
          return;
        }
        renderCart(data.sections);
        var drawer = $('#CartDrawer');
        if (drawer) openDrawer(drawer);
        else toast(theme.strings.added);
      })
      .catch(function () { toast(theme.strings.error, 'error'); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  function changeLine(line, quantity) {
    var drawer = $('#CartDrawer');
    if (drawer) drawer.classList.add('is-loading');
    fetch(theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: parseInt(line, 10),
        quantity: Math.max(0, parseInt(quantity, 10) || 0),
        sections: CART_SECTIONS,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status) toast(data.description || data.message || theme.strings.error, 'error');
        renderCart(data && data.sections);
      })
      .catch(function () { toast(theme.strings.error, 'error'); })
      .finally(function () { if (drawer) drawer.classList.remove('is-loading'); });
  }

  /* ---------- Global clicks ---------- */
  document.addEventListener('click', function (e) {
    var target = e.target;

    var megaBtn = target.closest('[data-mega-toggle]');
    if (megaBtn) { toggleMega(megaBtn); return; }
    if (!target.closest('[data-mega]')) closeMega();

    var opener = target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
      return;
    }

    if (target.closest('[data-drawer-close]') || target.matches('[data-overlay]')) {
      closeDrawer();
      return;
    }

    var cartLink = target.closest('[data-cart-open]');
    if (cartLink && theme.cartType === 'drawer' && $('#CartDrawer') && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openDrawer($('#CartDrawer'));
      return;
    }

    var lineBtn = target.closest('[data-line-change]');
    if (lineBtn) {
      e.preventDefault();
      changeLine(lineBtn.getAttribute('data-line'), lineBtn.getAttribute('data-qty'));
      return;
    }

    var qtyBtn = target.closest('[data-qty-minus], [data-qty-plus]');
    if (qtyBtn) {
      var wrap = qtyBtn.closest('[data-qty]');
      var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var min = parseInt(input.getAttribute('min') || '0', 10);
      var value = (parseInt(input.value, 10) || 0) + (qtyBtn.hasAttribute('data-qty-plus') ? 1 : -1);
      input.value = Math.max(min, value);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    closeMega();
    $$('[data-predictive-results]').forEach(function (box) { box.hidden = true; });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-type="add-to-cart-form"]');
    if (form) {
      e.preventDefault();
      addToCart(form);
      return;
    }
    var filterForm = e.target.closest('[data-filter-form]');
    if (filterForm) {
      e.preventDefault();
      navigateFilters(filterForm);
    }
  });

  /* ---------- Filters, sorting, cart page ---------- */
  function navigateFilters(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (String(value).trim() !== '') params.append(key, value);
    });
    window.location.href = window.location.pathname + '?' + params.toString();
  }

  document.addEventListener('change', function (e) {
    var target = e.target;

    var sortSelect = target.closest('[data-sort-select]');
    if (sortSelect) {
      var form = document.getElementById('FiltersForm');
      if (form) {
        var hidden = form.querySelector('[data-sort-hidden]');
        if (hidden) hidden.value = sortSelect.value;
        navigateFilters(form);
      } else {
        var p = new URLSearchParams(window.location.search);
        p.set('sort_by', sortSelect.value);
        window.location.search = p.toString();
      }
      return;
    }

    var filterForm = target.closest('[data-filter-form]');
    if (filterForm) {
      clearTimeout(filterForm._timer);
      filterForm._timer = setTimeout(function () { navigateFilters(filterForm); }, target.type === 'number' ? 500 : 60);
      return;
    }

    var cartQty = target.closest('[data-cart-qty]');
    if (cartQty) {
      var cartForm = cartQty.closest('form');
      var updateBtn = cartForm && cartForm.querySelector('[data-cart-update]');
      clearTimeout(cartForm._timer);
      cartForm._timer = setTimeout(function () {
        if (cartForm.requestSubmit && updateBtn) cartForm.requestSubmit(updateBtn);
        else if (updateBtn) updateBtn.click();
      }, 450);
    }
  });

  /* ---------- Header on scroll ---------- */
  window.addEventListener('scroll', function () {
    var header = $('[data-header]');
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 40);
  }, { passive: true });

  /* ---------- Predictive search ---------- */
  function initPredictiveSearch(root) {
    $$('[data-predictive-search]', root).forEach(function (form) {
      if (form.dataset.init) return;
      form.dataset.init = '1';
      var input = form.querySelector('[data-predictive-input]');
      var box = form.querySelector('[data-predictive-results]');
      if (!input || !box || !theme.routes.predictiveSearch) return;
      var controller = null;

      var run = debounce(function () {
        var q = input.value.trim();
        if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
        if (controller) controller.abort();
        controller = new AbortController();
        var url = theme.routes.predictiveSearch +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6' +
          '&resources[options][unavailable_products]=last&section_id=predictive-search';
        fetch(url, { signal: controller.signal })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var content = parseHTML(html).querySelector('[data-predictive-content]');
            box.innerHTML = content ? content.innerHTML : '';
            box.hidden = !content;
          })
          .catch(function (err) { if (err.name !== 'AbortError') box.hidden = true; });
      }, 250);

      input.addEventListener('input', run);
      input.addEventListener('focus', function () { if (box.innerHTML.trim()) box.hidden = false; });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
    });
  }

  /* ---------- Hero slider ---------- */
  function initSliders(root) {
    $$('[data-slider]', root).forEach(function (slider) {
      if (slider.dataset.init) return;
      slider.dataset.init = '1';
      var track = slider.querySelector('[data-slider-track]');
      var slides = $$('[data-slide]', track);
      var dots = $$('[data-slider-dot]', slider);
      if (!track || slides.length < 2) return;

      var index = 0;
      var timer = null;
      var delay = (parseInt(slider.getAttribute('data-autoplay') || '0', 10) || 0) * 1000;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function goTo(i) {
        index = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      }
      function sync() {
        index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
      }
      function stop() { clearInterval(timer); timer = null; }
      function start() {
        stop();
        if (delay > 0 && !reduced) timer = setInterval(function () { goTo(index + 1); }, delay);
      }

      track.addEventListener('scroll', debounce(sync, 60), { passive: true });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-slider-dot'), 10)); start(); });
      });
      var prev = slider.querySelector('[data-slider-prev]');
      var next = slider.querySelector('[data-slider-next]');
      if (prev) prev.addEventListener('click', function () { goTo(index - 1); start(); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); start(); });
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('touchstart', stop, { passive: true });

      slider._stop = stop;
      slider._goToSlide = function (el) { var i = slides.indexOf(el); if (i >= 0) goTo(i); };
      start();
    });
  }

  /* ---------- Countdowns ---------- */
  function initCountdowns(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      if (el.dataset.init) return;
      el.dataset.init = '1';
      var mode = el.getAttribute('data-mode');
      var raw = (el.getAttribute('data-end') || '').trim();
      var end = null;
      if (mode === 'date' && raw) {
        var iso = raw.replace(' ', 'T');
        if (iso.length <= 10) iso += 'T23:59:59';
        var d = new Date(iso);
        if (!isNaN(d.getTime())) end = d;
      }
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var out = function (k) { return el.querySelector('[data-cd="' + k + '"]'); };
      var daysWrap = el.querySelector('[data-cd-wrap="days"]');
      var interval = null;

      function target() {
        if (end) return end;
        var t = new Date();
        t.setHours(23, 59, 59, 999);
        return t;
      }

      function tick() {
        var diff = Math.max(0, target().getTime() - Date.now());
        if (end && diff === 0) {
          el.hidden = true;
          clearInterval(interval);
          return;
        }
        var s = Math.floor(diff / 1000);
        var days = Math.floor(s / 86400);
        var parts = {
          days: days,
          hours: Math.floor((s % 86400) / 3600),
          minutes: Math.floor((s % 3600) / 60),
          seconds: s % 60
        };
        Object.keys(parts).forEach(function (k) { var o = out(k); if (o) o.textContent = pad(parts[k]); });
        if (daysWrap) daysWrap.hidden = days === 0;
      }

      tick();
      interval = setInterval(tick, 1000);
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(section) {
    var track = section.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-thumb]', section);
    var thumbsWrap = thumbs.length ? thumbs[0].parentElement : null;

    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function goTo(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
    function markThumb(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      var t = thumbs[i];
      if (t && thumbsWrap) thumbsWrap.scrollTo({ left: t.offsetLeft - thumbsWrap.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    }

    section._goToMedia = function (id, instant) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(id)) { goTo(i, instant); return; }
      }
    };

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { section._goToMedia(t.getAttribute('data-thumb')); });
    });
    var prev = section.querySelector('[data-gallery-prev]');
    var next = section.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    track.addEventListener('scroll', debounce(function () { markThumb(current()); }, 80), { passive: true });

    var active = section.querySelector('.gallery__thumb.is-active');
    if (active) section._goToMedia(active.getAttribute('data-thumb'), true);
  }

  /* ---------- Product: variant picker ---------- */
  function initProducts(root) {
    $$('[data-product]', root).forEach(function (section) {
      if (section.dataset.init) return;
      section.dataset.init = '1';
      initGallery(section);

      var json = section.querySelector('[data-product-variants]');
      var inputs = $$('[data-option-index]', section);
      if (!json || !inputs.length) return;
      var variants;
      try { variants = JSON.parse(json.textContent); } catch (err) { return; }

      function selected() {
        var sel = [];
        inputs.forEach(function (i) { if (i.checked) sel[parseInt(i.getAttribute('data-option-index'), 10)] = i.value; });
        return sel;
      }
      function matches(v, sel) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      }
      function markAvailability(sel) {
        inputs.forEach(function (inp) {
          var idx = parseInt(inp.getAttribute('data-option-index'), 10);
          var test = sel.slice();
          test[idx] = inp.value;
          var ok = variants.some(function (v) { return v.available && matches(v, test); });
          var pill = inp.closest('.pill');
          if (pill) pill.classList.toggle('is-unavailable', !ok);
        });
      }

      function update() {
        var sel = selected();
        markAvailability(sel);
        sel.forEach(function (val, i) {
          var label = section.querySelector('[data-option-label="' + i + '"]');
          if (label) label.textContent = val;
        });

        var variant = variants.find(function (v) { return matches(v, sel); });
        var btn = section.querySelector('[data-add-button]');
        var btnText = section.querySelector('[data-add-text]');
        if (!variant) {
          if (btn) btn.disabled = true;
          if (btnText) btnText.textContent = theme.strings.unavailable;
          return;
        }

        var idInput = section.querySelector('[data-variant-id]');
        if (idInput) idInput.value = variant.id;
        if (btn) btn.disabled = !variant.available;
        if (btnText) btnText.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;

        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var cur = section.querySelector('[data-price-current]');
        var cmp = section.querySelector('[data-price-compare]');
        var save = section.querySelector('[data-price-save]');
        var badge = section.querySelector('[data-discount-badge]');
        if (cur) { cur.innerHTML = formatMoney(variant.price); cur.classList.toggle('is-sale', !!onSale); }
        if (cmp) { cmp.hidden = !onSale; cmp.innerHTML = onSale ? formatMoney(variant.compare_at_price) : ''; }
        if (save) {
          save.hidden = !onSale;
          save.innerHTML = onSale ? String(theme.strings.youSave).replace('[amount]', formatMoney(variant.compare_at_price - variant.price)) : '';
        }
        if (badge) {
          badge.hidden = !onSale;
          if (onSale) badge.textContent = '−' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
        }

        var stock = section.querySelector('[data-stock]');
        if (stock) {
          stock.textContent = variant.available ? theme.strings.inStock : theme.strings.outOfStock;
          stock.classList.toggle('stock--in', variant.available);
          stock.classList.toggle('stock--out', !variant.available);
        }
        var sku = section.querySelector('[data-sku]');
        if (sku) {
          sku.hidden = !variant.sku;
          var skuValue = sku.querySelector('[data-sku-value]');
          if (skuValue) skuValue.textContent = variant.sku || '';
        }

        var baseUrl = section.getAttribute('data-url');
        if (baseUrl && window.history.replaceState) {
          window.history.replaceState({}, '', baseUrl + '?variant=' + variant.id);
        }
        if (variant.featured_media && section._goToMedia) section._goToMedia(variant.featured_media.id);
      }

      inputs.forEach(function (i) { i.addEventListener('change', update); });
      markAvailability(selected());
    });
  }

  /* ---------- Recommendations ---------- */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      if (el.dataset.init || !el.getAttribute('data-url')) return;
      el.dataset.init = '1';
      if (el.querySelector('.product-grid')) return;
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = parseHTML(html).querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            initReveal(el);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var observer = null;
  function initReveal(root) {
    var els = $$('[data-reveal]:not(.is-visible)', root);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || document.documentElement.classList.contains('no-reveal')) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0.08 });
    }
    els.forEach(function (el) {
      var siblings = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.hasAttribute('data-reveal'); }) : [];
      var i = siblings.indexOf(el);
      el.style.transitionDelay = Math.min(Math.max(i, 0), 6) * 80 + 'ms';
      observer.observe(el);
    });
  }

  /* ---------- Init ---------- */
  function initAll(root) {
    root = root || document;
    initSliders(root);
    initCountdowns(root);
    initProducts(root);
    initPredictiveSearch(root);
    initRecommendations(root);
    initReveal(root);
  }

  hoistDrawers();
  initAll(document);

  /* Shopify theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    hoistDrawers();
    initAll(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-slide]');
    if (slide) {
      var slider = slide.closest('[data-slider]');
      if (slider && slider._stop) slider._stop();
      if (slider && slider._goToSlide) slider._goToSlide(slide);
    }
  });
})();
